import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SettingsStickySaveFooter from 'settings-ui-lib/components/SettingsStickySaveFooter';
import { validName } from '../records/UserProfile';
import { connect } from 'react-redux';
import { getCurrentUserProfile } from '../selectors/EntitySelector';
import { clearAllChanges, saveStagedChanges } from '../actions/StagingActions';
import { PHONE, PROFILE_FIRST_NAME, PROFILE_LAST_NAME } from '../constants/StagingDataKeys';
import { jsx as _jsx } from "react/jsx-runtime";
class UserPreferencesStickySave extends Component {
  constructor(props) {
    super(props);
    this.handleSaveClicked = this.handleSaveClicked.bind(this);
    this.handleCancelClicked = this.handleCancelClicked.bind(this);
  }
  handleSaveClicked() {
    this.props.saveStagedChanges();
  }
  handleCancelClicked() {
    this.props.clearAllChanges();
  }
  isStagedChangesValid() {
    const {
      stagedChanges
    } = this.props;
    if (stagedChanges.has(PROFILE_FIRST_NAME) && !validName(stagedChanges.get(PROFILE_FIRST_NAME))) {
      return false;
    }
    if (stagedChanges.has(PROFILE_LAST_NAME) && !validName(stagedChanges.get(PROFILE_LAST_NAME))) {
      return false;
    }
    if (stagedChanges.has(PHONE) && stagedChanges.get(PHONE).length > 40) {
      return false;
    }
    return true;
  }

  // TODO: I18n & save disabeld e.g. name validation issue
  render() {
    const {
      stagedChanges
    } = this.props;
    return /*#__PURE__*/_jsx(SettingsStickySaveFooter, {
      saveDisabled: !this.isStagedChangesValid(),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingsui.pendingChanges",
        options: {
          count: stagedChanges.size
        }
      }),
      disabledTooltipProps: {
        placement: 'top right'
      },
      shouldRender: stagedChanges.size > 0,
      onCancel: this.handleCancelClicked,
      onSave: this.handleSaveClicked
    });
  }
}
UserPreferencesStickySave.propTypes = {
  stagedChanges: PropTypes.object.isRequired,
  saveStagedChanges: PropTypes.func.isRequired,
  clearAllChanges: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    profile: getCurrentUserProfile(state),
    stagedChanges: state.stagedChanges
  };
};
export default connect(mapStateToProps, {
  saveStagedChanges,
  clearAllChanges
})(UserPreferencesStickySave);